<template>
  <div class='login'>
    <navigator class='header' title="登录" :routePath='"/auth/regist"'></navigator>

    <div class='body'>
      
      <mt-field class='password1' placeholder="请输入密码" type="password" v-model="password1"></mt-field>

      <mt-field class='password2' placeholder="请再次输入密码" type="password" v-model="password2"></mt-field>

      <div class='foot_bottom'>
        <van-button text='登录' @click.native='login' block />
      </div>

    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      password1: '',
      password2: '',

      duration: 1500,
    };
  },
  methods: {
    ...mapMutations(['change_token', 'change_firstLogin', 'change_authorizedCode', 'change_user']),
    login() {
      const valid = /^(\w){8,}$/;
      if (!this.password1) {
        Toast.fail({ duration: this.duration, message:  '请输入密码'});
        return;
      } else if (!valid.test(this.password1)) {
        Toast.fail({ duration: this.duration, message:  '密码仅支持8位以上数字、字母和下划线'});
        return;
      } else if (!this.password2) {
        Toast.fail({ duration: this.duration, message:  '请输入密码'});
        return;
      } else if (!valid.test(this.password2)) {
        Toast.fail({ duration: this.duration, message:  '密码仅支持8位以上数字、字母和下划线'});
        return;
      } else if (this.password1 !== this.password2) {
        Toast.fail({ duration: this.duration, message:  '两次密码不一致'});
        return;
      }

      this.$http.post(`${this.URL_PREFIX}/app/quick/auth/user/register`, {
        type: 1,
        userMobile: this.$route.query.userMobile,
        validateCode: this.$route.query.validateCode,
        ukey: this.$route.query.ukey,
        loginPassword: this.MD5(this.password1),
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_token(res.resData.token);
          this.getUserInfo(res.resData.token);
          // 此处必须使用这样粗暴的跳转方式
          // 因为iOS微信有坑，如果你用push或replace，实际上微信浏览器的地址没有发生改变，会导致首页扫码签名校验失败
          // 详情：https://segmentfault.com/q/1010000012588051
          window.location.href = this.URL_PREFIX_PAGE + this.curPath
        } else {
          Toast.fail({ duration: this.duration, message: res.resDesc});
        }
      });
    },
    getUserInfo(token) {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {}, {
        headers: { token: token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_user(res.resData);
        }
      });
    },
  },
  computed: {
    ...mapGetters(['curPath']),
  },
};
</script>


<style lang='scss' scoped>
  .login{
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    .body{
      .foot_bottom{
        padding: 0 .8rem;
        .van-button{
          border-radius: .666667rem;
          background: #d0011b;
          color: #fff;
          font-size: .48rem;
        }
      }
      .mint-field{
        padding: 0 .266667rem;
        height: 1.173333rem;
        line-height: 88px;
        font-size: .4rem;
        color: rgb(67, 67, 67);
        border-bottom: .013333rem solid rgb(245, 245, 245);
      }
      .password1{
        margin-top: 2.666667rem;
      }
      .password2{
        margin-bottom: .4rem;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/auth/Login.vue